import Dropdown from './dropdown'
import config from '../lib/config'
import templateFn from './profile-dropdown.ejs'
import authUrls from '../lib/auth-urls'
import { PeopleAndOrgsLoader } from '../lib/people-and-orgs-loader'
import { flushCache } from '../lib/service-cache'


class ProfileDropdown extends Dropdown {

  constructor(options) {
    super(options)
    this.templateFn = templateFn
    this.config = config
    this.loader = new PeopleAndOrgsLoader()
  }


  async init() {
    super.init()
    await this.loader.loadAccountMenu()
    if (this.$accountMenu) this.loadAccountMenu()
    else this.once('render', this.loadAccountMenu.bind(this))
  }

  loadAccountMenu() {
    this.$accountMenu.setAttribute('options', JSON.stringify({ signOutUrl: authUrls.getSignOutUrl() }))
    this.$accountMenu.addEventListener('signingOut', this.signingOut)
    this.$accountMenu.addEventListener('closeMenu', () => {
      this.close()
    })
  }

  signingOut() {
    flushCache()
  }
}

export default ProfileDropdown
